import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLocation } from 'react-router';
import { PageNotFound } from '../../shop/PageNotFound';
import { CollectionByGenrePage } from './by-genre/CollectionByGenrePage';
import { CompleteCollectionPage } from './complete/CompleteCollectionPage';
import { CollectionNewlyAddedPage } from './newly-added/CollectionNewlyAddedPage';
import { CollectionSearchResultPage } from '../../shared/search/CollectionSearchResultPage';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';
import { COLLECTION_NAVIGATION_V2, useFeature } from '../../shared/utils/togglz';
import { ProductSelectionProvider } from '../../shared/product-selection/ProductSelectionContext';
import { useLoanFormat } from '../../app-store/loanFormat/useLoanFormat';

const RouteSwitch: FC = () => {
    const { pathname, search } = useLocation();
    const {
        loanFormat: { urlKey: currentLoanFormat }
    } = useLoanFormat();
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);

    return (
        <Routes>
            <Route index element={<Navigate to={{ pathname: 'complete', search }} replace />} />
            <Route path="complete">
                <Route index element={<Navigate to={{ pathname: currentLoanFormat, search }} replace />} />
                <Route
                    path=":loanFormat"
                    element={
                        isCollectionNavigationV2Enabled ? (
                            <Navigate
                                to={{ pathname: pathname.replace('/collection', '/collectionmgmt'), search }}
                                replace
                            />
                        ) : (
                            <CheckLoanFormat>
                                <ProductSelectionProvider>
                                    <CompleteCollectionPage />
                                </ProductSelectionProvider>
                            </CheckLoanFormat>
                        )
                    }
                />
            </Route>
            <Route
                path="search/:loanFormat"
                element={
                    isCollectionNavigationV2Enabled ? (
                        <Navigate
                            to={{ pathname: pathname.replace('/collection', '/collectionmgmt'), search }}
                            replace
                        />
                    ) : (
                        <CheckLoanFormat>
                            <ProductSelectionProvider>
                                <CollectionSearchResultPage />
                            </ProductSelectionProvider>
                        </CheckLoanFormat>
                    )
                }
            />
            <Route path="newly-added">
                <Route index element={<Navigate to={{ pathname: currentLoanFormat, search }} replace />} />
                <Route
                    path=":loanFormat"
                    element={
                        isCollectionNavigationV2Enabled ? (
                            <Navigate
                                to={{
                                    pathname: pathname.replace('/collection/newly-added', '/collectionmgmt/collection'),
                                    search
                                }}
                                replace
                            />
                        ) : (
                            <CheckLoanFormat>
                                <ProductSelectionProvider>
                                    <CollectionNewlyAddedPage />
                                </ProductSelectionProvider>
                            </CheckLoanFormat>
                        )
                    }
                />
            </Route>
            <Route path="by-genre">
                <Route index element={<Navigate to={{ pathname: 'all', search }} replace />} />
                <Route
                    path=":loanFormat/:genre?/:subgenre?"
                    element={
                        isCollectionNavigationV2Enabled ? (
                            <Navigate
                                to={{
                                    pathname: pathname.replace('/collection/by-genre', '/collectionmgmt/collection'),
                                    search
                                }}
                                replace
                            />
                        ) : (
                            <CheckLoanFormat>
                                <ProductSelectionProvider>
                                    <CollectionByGenrePage />
                                </ProductSelectionProvider>
                            </CheckLoanFormat>
                        )
                    }
                />
            </Route>
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default RouteSwitch;
